import { StoreType } from '@tock/shared/utils/connect';
import { consumer, core } from '@tock/coretypes';

import { hasAnyMoniesInvolved } from 'utils/purchase';
import { isThirdPartyDeliveryVariety } from '@tock/shared/utils/offerings';
import { mapPurchasedOptions } from '@tock/shared/utils/option';
import ItemizedReceipt from './ItemizedReceipt';
import TransactionDetails from './TransactionDetails';
import _ from 'lodash';

interface ReservationReceiptProps {
  isAuthenticated: boolean;
  isPatronAuthTypesEmpty?: boolean;
  mobileTicketUrl?: string;
  onCancelTransfer?(): void;
  getContactRestaurantLink?(): string;
  onContinueToQuestions(): void;
  onFinishAccount?(): void;
  onModify?(): void;
  onShowCancelBooking(): void;
  onTransfer(): void;
  pastPurchase: StoreType['pastPurchase'];
  inVisitEdit: boolean;
  business: consumer.IBusinessConfig;
}

const ReservationReceipt: React.FC<ReservationReceiptProps> = ({
  pastPurchase: { pastPurchase, ticketTypeDetails, questions },
  business,
}) => {
  const purchase = _.last(_.values(pastPurchase)) as core.PastPurchase;

  return hasAnyMoniesInvolved(purchase) ? (
    <div>
      <ItemizedReceipt
        business={business}
        compAmount={purchase.compAmountCents}
        customCharge={purchase.purchasedCustomCharge as core.PurchasedCustomCharge[]}
        deliveryServiceProvider={purchase.ticketType?.deliveryServiceProvider}
        extraChargeDetails={purchase?.ticketType?.extraChargeDetails as core.ExtraChargeDetails}
        options={mapPurchasedOptions(purchase)}
        purchase={purchase}
        partySize={purchase?.ticketCount}
        purchaseFees={purchase.fee ?? []}
        title="Receipt"
        showTockFeeIfRequired={true}
        isVisitEdit={purchase.originatedAt === 'VISIT_EDIT'}
        isGratuityForThirdPartyDelivery={isThirdPartyDeliveryVariety(purchase.ticketType)}
        alwaysShowRefund={purchase.cancelledOrRefunded}
        ticketType={purchase.ticketType || undefined}
      />
      {purchase.totalPrice > 0 &&
        purchase.paymentTransaction &&
        purchase.paymentTransaction.length > 0 && (
          <div className="Receipt-container--section">
            <TransactionDetails purchase={purchase} />
          </div>
        )}
    </div>
  ) : null;
};

export default ReservationReceipt;
